// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Orbitron:wght@400;700&family=Share+Tech+Mono&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Для корректного отображения шрифтов 'Orbitron' и 'Share Tech Mono'
  их необходимо импортировать в ваш проект. Например, добавьте эти строки
  в ваш основной CSS-файл (src/index.css) или в секцию <head> public/index.html:

  @import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400;700&family=Share+Tech+Mono&display=swap');
*/

.landing-page-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* Занимает всю высоту видимой области */
  background-color: #0A0015; /* Очень темный, почти черный с фиолетовым оттенком */
  color: #CCEEFF; /* Светлый фиолетово-голубой текст */
  font-family: 'Orbitron', sans-serif; /* Основной футуристический шрифт */
  overflow: hidden; /* Предотвращает прокрутку от декораций */
}

.landing-main-content {
  flex-grow: 1; /* Занимает доступное пространство, прижимая футер к низу */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  position: relative;
  z-index: 1; /* Гарантирует, что контент поверх фона */
}

.landing-title {
  font-size: 3.5em;
  font-weight: 700;
  letter-spacing: 3px;
  margin-bottom: 15px;

  /* Градиентный текст с эффектом свечения */
  background: linear-gradient(90deg, #A75DFF, #CCEEFF, #A75DFF); /* Фиолетово-голубой градиент */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text; /* Стандарт */
  color: transparent; /* Fallback */
  text-shadow: 0 0 20px rgba(175, 93, 255, 0.7); /* Сильное фиолетовое свечение */
}

.landing-subtitle {
  font-family: 'Share Tech Mono', monospace; /* Моноширинный шрифт для tech-вида */
  font-size: 1.2em;
  margin-bottom: 50px;
  color: #E0BBE4; /* Мягкий фиолетовый для подзаголовка */
  letter-spacing: 1px;
}

.button-group {
  display: flex;
  gap: 30px; /* Расстояние между кнопками */
  z-index: 2; /* Убедимся, что кнопки над фоновыми элементами */
}
.action-button {
  padding: 18px 35px;
  font-size: 1.3em;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  cursor: pointer;
  border: 2px solid #A75DFF; /* Фиолетовая рамка */
  border-radius: 8px;
  background-color: rgba(167, 93, 255, 0.1); /* Полупрозрачный фиолетовый фон */
  color: #CCEEFF; /* Светлый текст */
  font-family: 'Orbitron', sans-serif;
  transition: all 0.3s ease; /* Плавные переходы */
  box-shadow: 0 0 15px rgba(175, 93, 255, 0.4); /* Мягкое свечение */
  outline: none; /* Убираем стандартную обводку при фокусе */
}

.action-button:hover,
.action-button:focus {
  background-color: rgba(167, 93, 255, 0.25); /* Более насыщенный фон при наведении/фокусе */
  color: #FFFFFF; /* Белый текст */
  border-color: #CCEEFF; /* Светлая рамка */
  box-shadow: 0 0 25px rgba(204, 238, 255, 0.7), 0 0 40px rgba(175, 93, 255, 0.5); /* Более сильное свечение */
  transform: translateY(-5px); /* Небольшой подъем */
}

/* Адаптивность */
@media (max-width: 768px) {
  .landing-title {
    font-size: 2.5em;
    letter-spacing: 2px;
  }

  .landing-subtitle {
    font-size: 1em;
    margin-bottom: 30px;
  }

  .button-group {
    flex-direction: column; /* Кнопки в столбик на маленьких экранах */
    gap: 20px;
  }

  .action-button {
    padding: 15px 25px;
    font-size: 1.1em;
    width: 80%; /* Занимают большую часть ширины */
    max-width: 300px;
  }
}

@media (max-width: 480px) {
  .landing-title {
    font-size: 2em;
  }

  .landing-subtitle {
    font-size: 0.9em;
  }

  .action-button {
    font-size: 1em;
    padding: 12px 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/style/home.css"],"names":[],"mappings":"AAAA;;;;;;CAMC;;AAGD;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB,EAAE,wCAAwC;EAC3D,yBAAyB,EAAE,qDAAqD;EAChF,cAAc,EAAE,oCAAoC;EACpD,mCAAmC,EAAE,mCAAmC;EACxE,gBAAgB,EAAE,yCAAyC;AAC7D;;AAEA;EACE,YAAY,EAAE,2DAA2D;EACzE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU,EAAE,yCAAyC;AACvD;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;;EAEnB,0CAA0C;EAC1C,6DAA6D,EAAE,+BAA+B;EAC9F,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB,EAAE,aAAa;EACpC,kBAAkB,EAAE,aAAa;EACjC,6CAA6C,EAAE,gCAAgC;AACjF;;AAEA;EACE,yCAAyC,EAAE,qCAAqC;EAChF,gBAAgB;EAChB,mBAAmB;EACnB,cAAc,EAAE,uCAAuC;EACvD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS,EAAE,8BAA8B;EACzC,UAAU,EAAE,iDAAiD;AAC/D;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,yBAAyB,EAAE,qBAAqB;EAChD,kBAAkB;EAClB,yCAAyC,EAAE,kCAAkC;EAC7E,cAAc,EAAE,kBAAkB;EAClC,mCAAmC;EACnC,yBAAyB,EAAE,qBAAqB;EAChD,4CAA4C,EAAE,oBAAoB;EAClE,aAAa,EAAE,2CAA2C;AAC5D;;AAEA;;EAEE,0CAA0C,EAAE,8CAA8C;EAC1F,cAAc,EAAE,gBAAgB;EAChC,qBAAqB,EAAE,kBAAkB;EACzC,+EAA+E,EAAE,2BAA2B;EAC5G,2BAA2B,EAAE,qBAAqB;AACpD;;AAEA,iBAAiB;AACjB;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,sBAAsB,EAAE,0CAA0C;IAClE,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,UAAU,EAAE,kCAAkC;IAC9C,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;AACF","sourcesContent":["/*\n  Для корректного отображения шрифтов 'Orbitron' и 'Share Tech Mono'\n  их необходимо импортировать в ваш проект. Например, добавьте эти строки\n  в ваш основной CSS-файл (src/index.css) или в секцию <head> public/index.html:\n\n  @import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400;700&family=Share+Tech+Mono&display=swap');\n*/\n@import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400;700&family=Share+Tech+Mono&display=swap');\n\n.landing-page-container {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh; /* Занимает всю высоту видимой области */\n  background-color: #0A0015; /* Очень темный, почти черный с фиолетовым оттенком */\n  color: #CCEEFF; /* Светлый фиолетово-голубой текст */\n  font-family: 'Orbitron', sans-serif; /* Основной футуристический шрифт */\n  overflow: hidden; /* Предотвращает прокрутку от декораций */\n}\n\n.landing-main-content {\n  flex-grow: 1; /* Занимает доступное пространство, прижимая футер к низу */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n  text-align: center;\n  position: relative;\n  z-index: 1; /* Гарантирует, что контент поверх фона */\n}\n\n.landing-title {\n  font-size: 3.5em;\n  font-weight: 700;\n  letter-spacing: 3px;\n  margin-bottom: 15px;\n\n  /* Градиентный текст с эффектом свечения */\n  background: linear-gradient(90deg, #A75DFF, #CCEEFF, #A75DFF); /* Фиолетово-голубой градиент */\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text; /* Стандарт */\n  color: transparent; /* Fallback */\n  text-shadow: 0 0 20px rgba(175, 93, 255, 0.7); /* Сильное фиолетовое свечение */\n}\n\n.landing-subtitle {\n  font-family: 'Share Tech Mono', monospace; /* Моноширинный шрифт для tech-вида */\n  font-size: 1.2em;\n  margin-bottom: 50px;\n  color: #E0BBE4; /* Мягкий фиолетовый для подзаголовка */\n  letter-spacing: 1px;\n}\n\n.button-group {\n  display: flex;\n  gap: 30px; /* Расстояние между кнопками */\n  z-index: 2; /* Убедимся, что кнопки над фоновыми элементами */\n}\n.action-button {\n  padding: 18px 35px;\n  font-size: 1.3em;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n  cursor: pointer;\n  border: 2px solid #A75DFF; /* Фиолетовая рамка */\n  border-radius: 8px;\n  background-color: rgba(167, 93, 255, 0.1); /* Полупрозрачный фиолетовый фон */\n  color: #CCEEFF; /* Светлый текст */\n  font-family: 'Orbitron', sans-serif;\n  transition: all 0.3s ease; /* Плавные переходы */\n  box-shadow: 0 0 15px rgba(175, 93, 255, 0.4); /* Мягкое свечение */\n  outline: none; /* Убираем стандартную обводку при фокусе */\n}\n\n.action-button:hover,\n.action-button:focus {\n  background-color: rgba(167, 93, 255, 0.25); /* Более насыщенный фон при наведении/фокусе */\n  color: #FFFFFF; /* Белый текст */\n  border-color: #CCEEFF; /* Светлая рамка */\n  box-shadow: 0 0 25px rgba(204, 238, 255, 0.7), 0 0 40px rgba(175, 93, 255, 0.5); /* Более сильное свечение */\n  transform: translateY(-5px); /* Небольшой подъем */\n}\n\n/* Адаптивность */\n@media (max-width: 768px) {\n  .landing-title {\n    font-size: 2.5em;\n    letter-spacing: 2px;\n  }\n\n  .landing-subtitle {\n    font-size: 1em;\n    margin-bottom: 30px;\n  }\n\n  .button-group {\n    flex-direction: column; /* Кнопки в столбик на маленьких экранах */\n    gap: 20px;\n  }\n\n  .action-button {\n    padding: 15px 25px;\n    font-size: 1.1em;\n    width: 80%; /* Занимают большую часть ширины */\n    max-width: 300px;\n  }\n}\n\n@media (max-width: 480px) {\n  .landing-title {\n    font-size: 2em;\n  }\n\n  .landing-subtitle {\n    font-size: 0.9em;\n  }\n\n  .action-button {\n    font-size: 1em;\n    padding: 12px 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
